module.exports = __webpack_public_path__ + "static/img/21.5ea417a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/zh/21.png
// module id = FOB5
// module chunks = 0